import { Link } from "react-router-dom";
import { Button, useTheme } from "@dawa/ui";
import { Moon, Sun } from "lucide-react";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/features", label: "Fonctionnalités" },
  { to: "/pricing", label: "Tarifs" },
  { to: "/blog", label: "Blog" },
  { to: "/faq", label: "FAQ" },
  { to: "/about", label: "À propos" },
  { to: "/contact", label: "Contact" },
  { to: "/support", label: "Support" },
  { to: "/terms", label: "Conditions" },
  { to: "/privacy", label: "Confidentialité" },
  { to: "/sitemap", label: "Plan du site" },
];

export default function Footer() {
  const { theme, setTheme } = useTheme();
  const actual =
    theme === "system"
      ? (typeof document !== "undefined"
          ? (document.documentElement.getAttribute("data-theme") as "light" | "dark")
          : "light")
      : theme;
  const sha = (import.meta as any).env?.VITE_COMMIT_SHA as string | undefined;
  const short = sha ? sha.slice(0, 7) : undefined;
  return (
    <footer className="border-t border-muted/20 p-4 text-center text-xs text-muted">
      <div className="flex flex-col items-center justify-center gap-2 md:flex-row md:gap-4">
        <span>© {new Date().getFullYear()} DawaRedacc</span>
        {links.map(({ to, label }) => (
          <Link key={to} to={to}>
            {label}
          </Link>
        ))}
        <Button
          variant="ghost"
          size="sm"
          aria-label="Basculer le mode sombre"
          onClick={() => setTheme(actual === "dark" ? "light" : "dark")}
        >
          {actual === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
        {short && <span className="text-muted">Build {short}</span>}
      </div>
    </footer>
  );
}
